/**
 * Product review count — fills "N Reviews" under the product title.
 *
 * The reviews export (assets/yotpo-reviews.json) has no per-product aggregates,
 * so the count is derived by filtering the review rows on product_id. That file
 * also backs the reviews section, so both read the same numbers.
 *
 * The fetch is shared: several elements on a page (and the reviews section) would
 * otherwise each pull ~1MB. One in-flight promise is cached on window.
 */
(function () {
  'use strict';

  var CACHE_KEY = '__justiceReviewsPromise';

  function loadReviews(src) {
    if (!window[CACHE_KEY]) {
      window[CACHE_KEY] = fetch(src).then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.json();
      });
    }
    return window[CACHE_KEY];
  }

  function render(el) {
    var src = el.getAttribute('data-reviews-src');
    var productId = el.getAttribute('data-product-id');
    if (!src || !productId) return;

    loadReviews(src)
      .then(function (data) {
        var rows = (data && data.reviews) || [];
        var count = 0;
        for (var i = 0; i < rows.length; i++) {
          if (String(rows[i].product_id) === productId) count++;
        }

        // No reviews: leave the element hidden rather than printing "0 Reviews",
        // which reads as a negative signal on a new product.
        if (!count) return;

        var one = el.getAttribute('data-label-one') || 'Review';
        var other = el.getAttribute('data-label-other') || 'Reviews';
        var label = count === 1 ? one : other;

        var text = el.querySelector('[data-review-count-text]');
        if (text) text.textContent = count + ' ' + label;
        el.removeAttribute('hidden');
      })
      .catch(function () {
        // Stay hidden. A missing count is unremarkable; a broken one is not.
      });
  }

  function init() {
    var els = document.querySelectorAll('[data-review-count]');
    for (var i = 0; i < els.length; i++) render(els[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
